import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActionListDialogComponent, ActionListDialogData } from './action-list-dialog.component';

import { Router } from '@angular/router';
import { GetterCampaignData, Statuses } from '@vendasta/campaigns';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Observable } from 'rxjs';
import { PartnerService } from '../../core/partner.service';
import { CampaignsService } from '../../marketing/marketing-automation-page/campaigns.service';
import { ActionsApiService } from './actions.api.service';

@Component({
  template: `
    <h2 mat-dialog-title>
      {{ 'ACTION_LISTS.PAUSE_CAMPAIGN_DIALOG.TITLE' | translate: { name: actionList.name } }}
    </h2>
    <mat-dialog-content class="dialog--overflow">
      <mat-spinner [strokeWidth]="4" [diameter]="40" *ngIf="campaignsLoading"></mat-spinner>
      <ng-container *ngIf="!campaignsLoading">
        <ng-container *ngIf="(campaigns || []).length > 0">
          <uikit-search-select
            [options]="campaigns"
            [showSearch]="true"
            [placeholderText]="'ACTION_LISTS.PAUSE_CAMPAIGN_DIALOG.SELECT_A_CAMPAIGN' | translate"
            [displayProperty]="'name'"
            [selected]="selectedCampaign"
            [width]="400"
            (selection)="selectedCampaign = $event"
          ></uikit-search-select>
          <p>{{ 'ACTION_LISTS.PAUSE_CAMPAIGN_DIALOG.PAUSE_SELECTED_CAMPAIGN' | translate }}</p>
        </ng-container>
        <ng-container *ngIf="(campaigns || []).length === 0">
          <p>{{ 'ACTION_LISTS.PAUSE_CAMPAIGN_DIALOG.NO_CAMPAIGNS_TO_PAUSE' | translate }}</p>
        </ng-container>
      </ng-container>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-raised-button color="primary" [disabled]="!selectedCampaign" (click)="pauseCampaign()">
        <ng-container *ngIf="!buttonLoading; else matSpinner">
          {{ 'ACTION_LISTS.PAUSE_CAMPAIGN_DIALOG.PAUSE_CAMPAIGN' | translate }}
        </ng-container>
        <ng-template #matSpinner>
          <mat-spinner [diameter]="30"></mat-spinner>
        </ng-template>
      </button>
      <button mat-button matDialogClose tabindex="-1" class="close-button">
        {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
      </button>
    </mat-dialog-actions>
  `,
  styleUrls: ['./action-list-dialog.component.scss', './action-list-actions.component.scss'],
  standalone: false,
})
export class PauseCampaignDialogComponent extends ActionListDialogComponent implements OnInit {
  campaigns: GetterCampaignData[];
  selectedCampaign: GetterCampaignData;
  campaignsLoading = true;
  buttonLoading = false;

  constructor(
    public dialogRef: MatDialogRef<PauseCampaignDialogComponent>,
    public router: Router,
    private campaignsService: CampaignsService,
    private partnerService: PartnerService,
    private actionsService: ActionsApiService,
    @Inject(MAT_DIALOG_DATA) private readonly data: ActionListDialogData,
    private snackbarService: SnackbarService,
  ) {
    super(dialogRef, router);
  }

  pauseCampaign(): void {
    if (!this.selectedCampaign || this.buttonLoading) {
      return;
    }

    this.buttonLoading = true;
    let response$: Observable<any>;
    if (this.data && this.data.useBulkActionsMicroservice) {
      response$ = this.actionsService.pauseListForCampaignBulkAction(
        this.selectedCampaign.campaignId,
        this.actionList.id,
      );
    } else {
      response$ = this.actionsService.pauseListForCampaign(this.selectedCampaign.campaignId, this.actionList.id);
    }
    response$.subscribe({
      next: () => {
        this.buttonLoading = false;
        this.snackbarService.successSnack(`Paused ${this.selectedCampaign.name} for ${this.actionList.name}.`);
        this.dialogRef.close(true);
      },
      error: () => {
        this.buttonLoading = false;
        this.snackbarService.errorSnack(
          `Failed to pause ${this.selectedCampaign.name} for ${this.actionList.name}. Please try again.`,
        );
      },
    });
  }

  ngOnInit(): void {
    this.campaignsService
      .listCampaigns(this.partnerService.partnerId, null, [
        Statuses.STATUSES_ACTIVE,
        Statuses.STATUSES_PUBLISHED,
        Statuses.STATUSES_ARCHIVED,
      ])
      .subscribe((campaigns) => {
        this.campaignsLoading = false;
        this.campaigns = campaigns;
      });
  }
}
